import {FC} from 'react';

interface Props {
  fill?: string;
  size?: number;
}

export const CustomersIcon: FC<Props> = ({fill = '#000', size = 48}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.3332 19.5L19.4998 21.6667L23.8332 17.3333M12.9998 16.25H8.6665C6.64742 16.25 5.63788 16.25 4.84154 16.5799C3.77975 17.0197 2.93617 17.8633 2.49636 18.925C2.1665 19.7214 2.1665 20.7309 2.1665 22.75M16.7915 3.56499C18.3796 4.20782 19.4998 5.76475 19.4998 7.58333C19.4998 9.40191 18.3796 10.9588 16.7915 11.6017M14.6248 7.58333C14.6248 9.97657 12.6847 11.9167 10.2915 11.9167C7.89827 11.9167 5.95817 9.97657 5.95817 7.58333C5.95817 5.1901 7.89827 3.25 10.2915 3.25C12.6847 3.25 14.6248 5.1901 14.6248 7.58333Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CustomersIcon;
